import PriceMakeup from './PriceMakeup';

export default PriceMakeup;